import { ResourceItem } from "./resources/ResourceItem";
import { createListResource, ListActions } from "./list";
import { createPostResource, PostActions } from "./post";
import { createUpdateResource, UpdateActions } from "./update";
import { createDetailResource, DetailActions } from "./detail";
import MegaraxClient from "./megaraxClient";
import { Resource } from "./resource";
import { DeleteActions, createDeleteResource } from "./delete";

export interface FullResourceActions<TDetail extends ResourceItem, TSimple>
  extends PostActions<TDetail>,
    UpdateActions<TDetail>,
    DetailActions<TDetail>,
    ListActions<TSimple>,
    DeleteActions {
  appName: string;
  service: string;
}

export function createFullResource<TDetail extends ResourceItem, TSimple>(
  apiUrl: string,
  detailDataTransform: (data: any) => TDetail,
  simpleDataTransform: (data: any) => TSimple = (data) => data,
): Resource<FullResourceActions<TDetail, TSimple>> {
  const [appName, service] = apiUrl.split("/");

  return (client: MegaraxClient) => ({
    ...createDetailResource(apiUrl, detailDataTransform)(client),
    ...createPostResource(apiUrl, detailDataTransform)(client),
    ...createListResource(apiUrl, simpleDataTransform)(client),
    ...createUpdateResource(apiUrl, detailDataTransform)(client),
    ...createDeleteResource(apiUrl)(client),
    appName,
    service,
  });
}

export const createFullClassResource = <TDetail extends ResourceItem, TSimple>(
  apiUrl: string,
  constructor: new (data: any) => TDetail,
  simpleDataTransform: (data: any) => TSimple = (data) => data,
) =>
  createFullResource(
    apiUrl,
    (data) => new constructor(data),
    simpleDataTransform,
  );
